// Header hide/show on scroll direction
// Changes top offset instead of transform to avoid creating a containing block
// that would break position:fixed on child elements (cart drawer).
(function() {
  var lastScrollY = window.scrollY;
  var hidden = false;
  var headerEl = null;

  function isCartDrawerOpen() {
    return document.body.classList.contains('cart-drawer-open');
  }

  function getHeader() {
    if (!headerEl) {
      headerEl = document.querySelector('.header-section')
        || document.querySelector('.custom-header-section')
        || document.querySelector('.shopify-section-group-header-group');
      if (headerEl) {
        headerEl.style.transition = 'top 0.3s ease';
      }
    }
    return headerEl;
  }

  function showHeader() {
    var el = getHeader();
    if (!el || !hidden) return;
    hidden = false;
    el.style.top = '';
  }

  window.addEventListener('scroll', function() {
    var el = getHeader();
    if (!el) return;

    if (isCartDrawerOpen()) {
      showHeader();
      lastScrollY = window.scrollY;
      return;
    }

    var currentScrollY = window.scrollY;

    if (currentScrollY > 100) {
      if (currentScrollY > lastScrollY && !hidden) {
        hidden = true;
        el.style.top = -el.offsetHeight + 'px';
      } else if (currentScrollY < lastScrollY && hidden) {
        showHeader();
      }
    } else if (hidden) {
      showHeader();
    }

    lastScrollY = currentScrollY;
  }, { passive: true });

  // Show header when any drawer opens (cart, mobile nav, search, etc.)
  document.addEventListener('headerDrawer:opened', showHeader);
  document.addEventListener('cart:open', showHeader);
})();
